"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Essentials_module_1 = tslib_1.__importDefault(require("./modules/Essentials.module"));
const loadEssentialsModule = () => ({
    hasRouter: false,
    modules: [(0, Essentials_module_1.default)()],
});
exports.default = loadEssentialsModule;
